import { Component } from '@angular/core';

@Component({
  selector: 'app-delivery-router',
  templateUrl: './delivery-router.component.html',
  standalone: false,
})
export class DeliveryRouterComponent {
  constructor() {}
}
